import * as BABYLON from 'babylonjs'

class Tree {
  constructor (mesh, label, index) {

    this.label = label
    
    this.view = new BABYLON.TransformNode("TreeGroup" + label )
    this.view.rotationQuaternion = null

    this.tree = mesh.createInstance(label + index)
    this.tree.parent = this.view
    this.tree.rotationQuaternion = null
    this.tree.rotation.y = Math.random() * (Math.PI * 2)

    this.collider = BABYLON.MeshBuilder.CreateBox("TreeCollider" + index, {size: 1,depth: 1.5});
    this.collider.position.y = .5
    this.collider.position.z = .75

    this.collider.parent = this.view
    this.collider.isVisible = false
  }

  setConfig(config) {
    this.view.position = config.position
    
    this.view.rotate(BABYLON.Axis.X, config.rotation.x, BABYLON.Space.WORLD)
    this.view.rotate(BABYLON.Axis.Y, config.rotation.y, BABYLON.Space.WORLD)
    this.view.rotate(BABYLON.Axis.Z, config.rotation.z, BABYLON.Space.WORLD)

    this.view.scaling = new BABYLON.Vector3( -config.scaling.x, config.scaling.y, config.scaling.z)
  }

  destroy() {
    this.collider = null
    this.tree.parent = null
    this.tree.isVisible = false
    this.tree.dispose()
  }
}

export default Tree